import React from 'react';
import { Form, Input, Select } from 'antd';

const { Option } = Select;

const ClassForm = ({ form, users = [], isEditMode = false }) => {
  const teachers = users.filter(u => u.role === 'CLASS_TEACHER');

  return (
    <Form form={form} layout="vertical" name="class_form">
      <Form.Item
        name="name"
        label="班级名称"
        rules={[{ required: true, message: '请输入班级名称!' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="teacherId"
        label="班主任"
        rules={[{ required: true, message: '请为班级指定一位班主任!' }]}
      >
        <Select placeholder="选择一位班主任" aria-label="选择班主任">
          {teachers.map(t => (
            <Option key={t.id} value={t.id}>{t.name}</Option>
          ))}
        </Select>
      </Form.Item>
    </Form>
  );
};

export default ClassForm;
